module.exports = __webpack_public_path__ + "img/up-arrow-icon.42348fbb.jpg";